
import { Row, Text } from '@client/shared/design';
import { cx } from '@client/shared/lib/cx.ts';
import { calendarLegendLabel } from './text.ts';
import styles from './CalendarLegend.module.css';

export type CalendarLegendItem =
  | 'selection'
  | 'yourBookings'
  | 'yourBooking'
  | 'otherAgents'
  | 'blocked';

const ITEM_SPEC: Record<CalendarLegendItem, { label: string; swatch: string | undefined }> = {
  selection: { label: calendarLegendLabel.yourSelection, swatch: styles.swatchSelection },
  yourBookings: { label: calendarLegendLabel.yourBookings, swatch: styles.swatchMine },
  yourBooking: { label: calendarLegendLabel.yourBooking, swatch: styles.swatchMine },
  otherAgents: { label: calendarLegendLabel.otherAgents, swatch: styles.swatchOther },
  blocked: { label: calendarLegendLabel.blocked, swatch: styles.swatchBlocked },
};

export interface CalendarLegendProps {
  items?: readonly CalendarLegendItem[];
  className?: string;
}

export function CalendarLegend({ items, className }: CalendarLegendProps) {
  if (!items || items.length === 0) return null;
  return (
    <Row gap={4} align="center" wrap className={cx(styles.legendKey, className)}>
      {items.map((item) => {
        const spec = ITEM_SPEC[item];
        return (
          <span key={item} className={styles.legendItem}>
            <span className={cx(styles.swatch, spec.swatch)} aria-hidden="true" />
            <Text as="span" size="xs" tone="soft">
              {spec.label}
            </Text>
          </span>
        );
      })}
    </Row>
  );
}
